<div class="scrollable-container">
  <div class="layout">

    <router-outlet></router-outlet>

  </div>
</div>

<app-toast aria-live="polite" aria-atomic="true"></app-toast>
